import { Grid, TextField, Typography } from '@mui/material';
import { CardComponent } from 'utils/components/card/CardComponent';

export const LegalInfoCard = ({ register }) => {
  return (
    <CardComponent title='Persona Moral' minWidth='100%'>
      <Grid container spacing={3} sx={{ width: '100%' }} mt={3} height={100}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Typography gutterBottom sx={{ fontSize: 14, fontWeight: 600 }}>
            RFC
          </Typography>
          <TextField
            fullWidth
            disabled
            placeholder='RFC'
            {...register('rfc')}
            // error={Boolean(errors.rfc)}
            // helperText={errors.rfc?.message}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Typography gutterBottom sx={{ fontSize: 14, fontWeight: 600 }}>
            Nombre comercial
          </Typography>
          <TextField
            fullWidth
            disabled
            placeholder='Nombre comercial'
            {...register('legalName')}
            // error={Boolean(errors.tradeName)}
            // helperText={errors.tradeName?.message}
          />
        </Grid>
      </Grid>
    </CardComponent>
  );
};
